export const stringToNumber = (value: string | number) =>
  Number.isNaN(value) ? null : value;
